<!-- =========================================================================================
  File Name: UserEditTabSocial.vue
  Description: User Edit Social Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div id="sponsor-edit-tab-info">
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/1">
        <div class="custom-head-wrap mb-5">
            <h1 class="cms-custom-heading">
                {{data_local.Name}}
            </h1>
        </div>
      </div>
      <!-- Col 1 -->
     <div class="vx-col w-full md:w-1/2 mt-4">

        <vs-input
          class="w-full icon-center"
          v-model="data_local.SocialLinks.Facebook"
          icon-pack="feather"
          icon="icon-facebook"
          label="Facebook"
          icon-no-border
             v-validate="{ url:{require_protocol: true },regex: /(?:http:\/\/)?(?:www\.)?facebook\.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[\w\-]*\/)*([\w\-]*)/ }"
          name="Facebook" />
          <span class="text-danger text-sm"  v-show="errors.has('Facebook')">{{ errors.first('Facebook') }}</span>
        </div>
         <div class="vx-col w-full md:w-1/2 mt-4">
        <vs-input
          class="w-full icon-center"
          v-model="data_local.SocialLinks.Twitter"
          icon-pack="feather"
          icon="icon-twitter"
          label="Twitter"
          icon-no-border
          v-validate="{ url:{require_protocol: true },regex: /(?:http:\/\/)?(?:www\.)?twitter\.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[\w\-]*\/)*([\w\-]*)/ }"
          name="Twitter" />
          <span class="text-danger text-sm"  v-show="errors.has('Twitter')">{{ errors.first('Twitter') }}</span>
        </div>
          <div class="vx-col w-full md:w-1/2 mt-4">
          <vs-input
            class="w-full icon-center mt-4"
            v-model="data_local.SocialLinks.LinkedIn"
            icon-pack="feather"
            icon="icon-linkedin"
            label="LinkedIn"
            icon-no-border
            v-validate="{ url:{require_protocol: true },regex: /(?:http(?:s)?:\/\/)?(?:www\.|\w\w\.)?linkedin\.com\/((?:in)\/(?:[a-zA-Z0-9-]{5,30}(?:\/)?)|(?:profile\/)(?:view\?id=[0-9]+))?/ }"
            name="LinkedIn" />
            <span class="text-danger text-sm"  v-show="errors.has('LinkedIn')">{{ errors.first('LinkedIn') }}</span>
        </div>
      <div class="vx-col w-full md:w-1/2 mt-4">
        <vs-input
          class="w-full icon-center mt-4"
          v-model="data_local.SocialLinks.GooglePlus"
          icon-pack="feather"
          icon="icon-instagram"
          label="Instagram"
          icon-no-border
          v-validate="{ url:{require_protocol: true },regex: /(?:(?:http|https):\/\/)?(?:www\.)?(?:instagram\.com|instagr\.am)\/([A-Za-z0-9-_\.]+)/im }"
          name="Instagram" />
          <span class="text-danger text-sm"  v-show="errors.has('Instagram')">{{ errors.first('Instagram') }}</span>
      </div>
        
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button class=" mt-2" @click="$router.push('/event/exhibitors')">Back To List</vs-button>
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm" color="success">Save & Exit</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return

      // Here will go your API call for updating data (Also remvoe eslint-disable)
      // You can get data in "this.data_local"

      /* eslint-enable */
      this.$vs.loading();
      const Id = this.$route.params.exhibitorId
      //alert(Id);
      this.$store.dispatch('exhibitorManagement/updateExhibitorSocialDetail', { id: Id, data: this.data_local})
        .then(res => { 
          //alert(res.message) 
          this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Exhibitor",
              text: "Exhibitor updated successfully.",
            });
            this.$vs.loading.close();
            this.$router.push("/event/exhibitors/"); 
        }) 
        .catch(err => {          
          //console.error(err) 
        })
    },
    reset_data () {
      this.data_local = Object.assign({}, this.data)
    }
  }
}
</script>
